import React from 'react'
import { Card, Form, Col } from 'react-bootstrap'

const WorksheetNumeric = (props) => {
    let lg = props.colLg ? props.colLg : 9;
    let md = props.colMd ? props.colMd : 12;
    if (props.print) {
        return (
            <Form.Group as={Col} lg={lg} md={md}>
                <Form.Label>{props.label}</Form.Label><br />{props.value}
            </Form.Group>
        );
    } else {
        return (
            <Form.Group as={Col} lg={lg} md={md}>
                <Form.Label>{props.label}</Form.Label>
                <Form.Control placeholder=""
                    name={props.name}
                    type="number"
                    id={props.name}
                    value={props.value}
                    onBlur={props.onBlur}
                    isInvalid={props.error}
                    onChange={props.onChangeInput} />
                <Form.Text className="text-muted">{props.description}</Form.Text>
                <Form.Control.Feedback type="invalid">
                    Initial and Revised values cannot be the same.
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export default WorksheetNumeric